import { StyleRules } from '@material-ui/core/styles';
import { TabClassKey } from '@material-ui/core/Tab';

import { core as theme } from '../styles/core';

export const MuiTab: Partial<StyleRules<TabClassKey>> = {
  root: {
    ...theme.typography.body1,
    padding: 0,
    minHeight: 64,
    maxWidth: 'initial',
    minWidth: 'initial',
    color: theme.palette.grey[600],
    textTransform: 'none',
    '@media (min-width: 600px)': {
      minWidth: 'initial',
    },
    '.MuiTabs-vertical &&': {
      minHeight: '40px',
      marginLeft: 0,
    },
  },
  textColorPrimary: {
    color: theme.palette.grey[600],
    '&$selected': {
      '&:hover': {
        color: theme.palette.primary.dark,
      },
    },
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
  wrapper: {
    '.MuiTabs-vertical &': {
      alignItems: 'flex-start',
      paddingLeft: theme.spacing(1),
    },
  },
};
